import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-tracks-complete-checkmark';
export var ID = 'icon-tracks-complete-checkmark';
/* eslint-disable max-len */

export var SVGTracksCompleteCheckmark = function SVGTracksCompleteCheckmark() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 53 54"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M50.1496177,27.0506304 C50.1496177,13.7829675 39.6213213,3.04042627 26.6496177,3.04042627 C13.6779141,3.04042627 3.14961774,13.7829675 3.14961774,27.0506304 C3.14961774,40.3169205 13.6786534,51.0608344 26.6496177,51.0608344 C39.620582,51.0608344 50.1496177,40.3169205 50.1496177,27.0506304 Z M53.1496177,27.0506304 C53.1496177,41.9603607 41.2911534,54.0608344 26.6496177,54.0608344 C12.008082,54.0608344 0.149617744,41.9603607 0.149617744,27.0506304 C0.149617744,12.1394895 12.0073822,0.0404262694 26.6496177,0.0404262694 C41.2918532,0.0404262694 53.1496177,12.1394895 53.1496177,27.0506304 Z"
  }), React.createElement("polygon", {
    points: "17.9205073 26.8429646 15.7991869 28.9642849 24.0535027 37.2186007 39.6582302 21.6138731 37.5369098 19.4925528 24.0535027 32.97596"
  })));
};
/* eslint-disable max-len */

var TracksCompleteCheckmark = function TracksCompleteCheckmark(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGTracksCompleteCheckmark
  });
};

TracksCompleteCheckmark.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default TracksCompleteCheckmark;